// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-download {
  padding: 80px 20px;
  background: linear-gradient(135deg, #eef2ff 0%, #ede9fe 100%);
  overflow: hidden;
}

.app-download-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 60px;
}

.app-download-text {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.app-download-badges {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.app-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #111827;
  color: #fff;
  text-decoration: none;
  border-radius: 14px;
  padding: 12px 20px;
  font-family: inherit;
  transition: transform 0.15s, box-shadow 0.15s;
  min-width: 170px;
}

.app-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}

.app-badge svg { flex-shrink: 0; }

.app-badge span {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  font-size: 0.95rem;
  font-weight: 700;
}

.app-badge span small {
  font-size: 0.68rem;
  font-weight: 400;
  opacity: 0.75;
  text-transform: none;
  letter-spacing: 0;
}

.app-badge.google { background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); }
.app-badge.apple  { background: #111827; }

/* decorative art */
.app-download-art {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.app-download-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
}

.app-download-circle-1 {
  width: 340px;
  height: 340px;
  background: var(--p1);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.app-download-circle-2 {
  width: 200px;
  height: 200px;
  background: var(--p2);
  top: 10%;
  left: 60%;
  transform: translate(-50%, -50%);
}

.app-download-phone {
  width: 220px;
  border-radius: 36px;
  box-shadow: 0 32px 80px rgba(79, 70, 229, 0.22), 0 8px 24px rgba(0,0,0,0.1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  border: 8px solid #111827;
  background: #111827;
}

.app-download-phone::before {
  content: '';
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 8px;
  background: #111827;
  border-radius: 4px;
  z-index: 2;
}

.app-download-screenshot {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 28px;
}

@media (max-width: 768px) {
  .app-download-inner {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .app-download-phone { width: 180px; }
}

@media (max-width: 480px) {
  .app-download-badges { flex-direction: column; }
  .app-badge { min-width: unset; }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppDownload.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,iBAAiB,cAAc,EAAE;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,oBAAoB,6DAA6D,EAAE;AACnF,oBAAoB,mBAAmB,EAAE;;AAEzC,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2EAA2E;EAC3E,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA,sBAAsB,YAAY,EAAE;AACtC;;AAEA;EACE,uBAAuB,sBAAsB,EAAE;EAC/C,aAAa,gBAAgB,EAAE;AACjC","sourcesContent":[".app-download {\n  padding: 80px 20px;\n  background: linear-gradient(135deg, #eef2ff 0%, #ede9fe 100%);\n  overflow: hidden;\n}\n\n.app-download-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 60px;\n}\n\n.app-download-text {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.app-download-badges {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.app-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: #111827;\n  color: #fff;\n  text-decoration: none;\n  border-radius: 14px;\n  padding: 12px 20px;\n  font-family: inherit;\n  transition: transform 0.15s, box-shadow 0.15s;\n  min-width: 170px;\n}\n\n.app-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n}\n\n.app-badge svg { flex-shrink: 0; }\n\n.app-badge span {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.app-badge span small {\n  font-size: 0.68rem;\n  font-weight: 400;\n  opacity: 0.75;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.app-badge.google { background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%); }\n.app-badge.apple  { background: #111827; }\n\n/* decorative art */\n.app-download-art {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.app-download-circle {\n  position: absolute;\n  border-radius: 50%;\n  opacity: 0.15;\n  pointer-events: none;\n}\n\n.app-download-circle-1 {\n  width: 340px;\n  height: 340px;\n  background: var(--p1);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.app-download-circle-2 {\n  width: 200px;\n  height: 200px;\n  background: var(--p2);\n  top: 10%;\n  left: 60%;\n  transform: translate(-50%, -50%);\n}\n\n.app-download-phone {\n  width: 220px;\n  border-radius: 36px;\n  box-shadow: 0 32px 80px rgba(79, 70, 229, 0.22), 0 8px 24px rgba(0,0,0,0.1);\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  border: 8px solid #111827;\n  background: #111827;\n}\n\n.app-download-phone::before {\n  content: '';\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 8px;\n  background: #111827;\n  border-radius: 4px;\n  z-index: 2;\n}\n\n.app-download-screenshot {\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 28px;\n}\n\n@media (max-width: 768px) {\n  .app-download-inner {\n    grid-template-columns: 1fr;\n    gap: 36px;\n  }\n  .app-download-phone { width: 180px; }\n}\n\n@media (max-width: 480px) {\n  .app-download-badges { flex-direction: column; }\n  .app-badge { min-width: unset; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
